import moment from 'moment'

export const parseStats = (stats: any) =>
	stats.map((locker: any) => ({
		bought: locker.counts.bought,
		overdue: locker.counts.overdue,
		used: locker.counts.used,
		date: moment(locker.data).format('DD.MM.YY')
	}))
